import { createSelector } from '@ngrx/store';
import { AppState } from 'src/store';

export const selectAllBases = (app: AppState) => app.bases.entities;

export function selectBaseById(baseId: string) {
  return createSelector(selectAllBases, (bases) => bases[baseId]);
}
